import { readStreamableValue } from "ai/rsc";
import { streamContent } from "../../app/actions/streamSubtopicContent";
import { CareerMap, Chapter, Pass2Option, Pass2Section, Pass2Sidequest } from '../../typesV2';

export async function runContentStream(
  setContentData: (content: string) => void,
  map: CareerMap,
  topic: Pass2Section | Pass2Option | Pass2Sidequest,
  activeChapter: Chapter,
  shouldContinueStreaming: { current: boolean }
): Promise<[string, Error | null]> {
  let content = '';
  let error = null;

  try {
    const contentStreamValue = await streamContent(
      map,
      topic,
      activeChapter
    );
    const streamValue = readStreamableValue(contentStreamValue);

    for await (const generatedContent of streamValue) {
      // Check if we should continue streaming
      if (!shouldContinueStreaming.current) {
        break;
      }
      setContentData(generatedContent as string);
    }
    return [content, error];
  } catch (err) {
    return [content, error];
  }
}
